module.exports = __webpack_public_path__ + "static/media/loading.0c98f010.gif";